export default function portfolioDropdown() {
  const portfolioDropdown = document.querySelector(".dropdown-portfolio");
  const portfolioDropdownMenu = document.querySelector(".top-portfolio");

  if (portfolioDropdown) {
    portfolioDropdown.addEventListener("click", function (e) {
      e.preventDefault();
      portfolioDropdownMenu.classList.add("animate");
      portfolioDropdownMenu.classList.toggle("active");
      portfolioDropdownMenu.attributes["aria-hidden"].value = portfolioDropdownMenu.attributes["aria-hidden"].value === "true" ? "false" : "true";
    });
  }
}
